export const INDUSTRIES = [
    { id: 'ShopandCommercialEstablishment', name: 'Shop and Commercial Establishment' },
    { id: 'SecurityAgencies', name: 'Security Agencies' },
    { id: 'BuildingandConstructionWorks', name: 'Building and Construction Works' },
    { id: 'Factory(BISF)', name: 'Factory' }
  ];

  INDUSTRIES.getNameById = function (id) {
  return this.find(industry => industry.id === id)?.name || id;
};


